export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// /~/d3-format/src/identity.js
// module id = nH7H
// module chunks = 0